import { useQuery } from "@tanstack/react-query";
import { api, qs } from "../client";
import type { ChatWindow } from "../types";

/**
 * Archived chat for a window, or everything past a cursor.
 *
 * The window is quantised by the caller (see chat/replay.ts) so playback advancing frame by
 * frame reuses one cached response instead of issuing a request per second -- the same trick
 * `useTimeline` uses for panning.
 */
export function useChatWindow(startMs: number | null, endMs: number | null, enabled = true) {
  const start = startMs === null ? null : new Date(startMs).toISOString();
  const end = endMs === null ? null : new Date(endMs).toISOString();
  const query = qs({ start, end, limit: 1000 });
  return useQuery({
    queryKey: ["chat", query],
    queryFn: () => api.get<ChatWindow>(`/api/chat${query}`),
    enabled: enabled && start !== null && end !== null,
    placeholderData: (previous) => previous,
    staleTime: 30_000,
  });
}
